import { render, staticRenderFns } from "./DeudaDelete.vue?vue&type=template&id=35848da6"
import script from "./DeudaDelete.vue?vue&type=script&lang=js"
export * from "./DeudaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports